import { defineComponent, ref } from 'vue';

const dimensions = {
    height: {
        clientProperty: 'clientHeight',
        innerProperty: 'innerHeight',
        marginProperty: 'marginTop',
        offsetProperty: 'offsetHeight',
        oppositeDimension: 'width',
    },
    width: {
        clientProperty: 'clientWidth',
        innerProperty: 'innerWidth',
        marginProperty: 'marginLeft',
        offsetProperty: 'offsetWidth',
        oppositeDimension: 'height',
    },
};
var script = defineComponent({
    name: 'TransitionResize',
    props: {
        horizontal: Boolean,
    },
    setup(props) {
        const dimension = props.horizontal ? 'width' : 'height';
        const { innerProperty, offsetProperty, oppositeDimension } = dimensions[dimension];
        const leaveMeasurement = ref(null);
        const measureElement = (element) => {
            const oppositeDimensionValue = getComputedStyle(element)[oppositeDimension];
            const origDimensionValue = getComputedStyle(element)[dimension];
            element.style.setProperty(oppositeDimension, oppositeDimensionValue);
            element.style.setProperty('position', 'absolute');
            element.style.setProperty('visibility', 'hidden');
            element.style.setProperty(dimension, 'auto');
            const elementSize = element[offsetProperty];
            const windowSize = window[innerProperty];
            const measurementNumber = Math.min(elementSize, windowSize);
            const measurement = `${measurementNumber}px`;
            element.style.removeProperty(oppositeDimension);
            element.style.removeProperty('position');
            element.style.removeProperty('visibility');
            element.style.setProperty(dimension, origDimensionValue);
            return measurement;
        };
        const beforeEnter = (element) => {
            element.style.setProperty(dimension, leaveMeasurement.value);
        };
        const enter = (element) => {
            const measurement = measureElement(element);
            requestAnimationFrame(() => {
                element.style.setProperty(dimension, measurement);
            });
        };
        const beforeLeave = (element) => {
            const measurement = measureElement(element);
            leaveMeasurement.value = measurement;
        };
        const removeExplicitDimension = (element) => {
            element.style.removeProperty(dimension);
            element.style.removeProperty('transform');
        };
        return {
            enter,
            beforeEnter,
            beforeLeave,
            removeExplicitDimension,
        };
    },
});

export { script as default };
